(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("ScrollBooster", [], factory);
	else if(typeof exports === 'object')
		exports["ScrollBooster"] = factory();
	else
		root["ScrollBooster"] = factory();
})(this, function() {
return 